import DicomPlusModal from './dicom-plus-modal/index.vue'
import DicomPlusMixin from '@/shared/mixins/dicom-plus.mixin'
import ProtocoloPrintMixin from '@/shared/mixins/protocolo-print.mixin'
import AnexarArquivosModal from './dicom-plus-modal/components/dicom-plus-modal-attach-file/index.vue'
import ExamSourceMixin from '@/shared/mixins/exam-source.mixin'
import { dateBrToInt } from '@/shared/utils/date-validator'
import constants from '../../shared/constants/constants'
import { showDialog } from '../../shared/sweetAlerts/showDialog'
import DicomPlusHistoricoGrid from './components/dicom-plus-historico-grid/index.vue'
import DicomPlusCancelamento from './dicom-plus-cancelamento/index.vue'
import PatientNameCell from '@/components/patient-name-cell/index.vue'

export default {
  name: 'dicom-plus',
  components: { DicomPlusModal, AnexarArquivosModal, DicomPlusHistoricoGrid, DicomPlusCancelamento, PatientNameCell },
  mixins: [DicomPlusMixin, ProtocoloPrintMixin, ExamSourceMixin],
  data() {
    return {
      showIdColumn: false,
      constants,
      headers: [
        this.$i18n.t('dicom_plus.id'),
        this.$i18n.t('dicom_plus.patient'),
        this.$i18n.t('dicom_plus.age'),
        this.$i18n.t('dicom_plus.sex'),
        this.$i18n.t('dicom_plus.category'),
        this.$i18n.t('dicom_plus.study'),
        this.$i18n.t('dicom_plus.exam_date'),
        this.$i18n.t('dicom_plus.received_date'),
        this.$i18n.t('dicom_plus.priority'),
        this.$i18n.t('dicom_plus.status'),
        this.$i18n.t('dicom_plus.unit'),
        this.$i18n.t('dicom_plus.actions')
      ],
      searchTerm: '',
      showModal: false,
      selectedExam: null,
      data: [],
      activeFilters: { Status: { value: 0 } },
      isLoading: false,
      currentPage: 1,
      pageSize: 20,
      pageCount: 1,
      totalItems: 0,
      categorias: [],
      prioridades: [],
      placeholder: this.$i18n.t('dicom_plus.placeholder_patient_name'),
      OrderColumn: 'dataExame',
      OrderBy: 'desc',
      filtroStatus: '',
      statusItems: [
        { id: 99, name: this.$i18n.t('dicom_plus.status_canceled') },
        { id: 2, name: this.$i18n.t('dicom_plus.status_exam_created') },
        { id: 4, name: this.$i18n.t('dicom_plus.status_expired') },
        { id: 5, name: this.$i18n.t('dicom_plus.status_deleted') },
        { id: 3, name: this.$i18n.t('dicom_plus.status_failed') },
        { id: 0, name: this.$i18n.t('dicom_plus.status_pending') },
        { id: 1, name: this.$i18n.t('dicom_plus.status_reviewed') },
        { id: null, name: this.$i18n.t('dicom_plus.status_all') },
      ],
      filtroPrioridade: '',
      prioridadesItems: [
        { id: 3, name: this.$i18n.t('dicom_plus.priority_emergency') },
        { id: 1, name: this.$i18n.t('dicom_plus.priority_routine') },
        { id: 2, name: this.$i18n.t('dicom_plus.priority_urgency') },
      ],
      showAnexarArquivos: false,
      showHistoricoExame: false,
      historico: [],
      detalhes: [],
      examAnexo: null,
      anexoTipoOptions: [],
      tipoAnexo: null,
      savedFiles: [],
      showCancelModal: false,
      examToCancel: null,
      localMotivoCancelamento: '',
      dicomPlusIdSelecionado: null,
    }
  },
  computed: {
    filteredData() {
      return this.data
    },
    showCancelButton() {
      return import.meta.env.VITE_SHOW_CANCEL_EXAM_DICOMPLUS === constants.STATUS_BIT.ATIVO
    }
  },
  methods: {
    // Carregar dados
    async fetchExams(filters = null, page = this.currentPage) {
      this.isLoading = true
      try {
        this.$root.$emit('showLoading')
        const source = JSON.parse(localStorage.getItem('selectedSource') || 'null')
        const fonteIdFromStorage = source?.id

        const baseFilters = filters ?? (this.filtrosAtuaisOuDoSeuComponente || {})

        const mergedFilters = { ...baseFilters }

        if (!mergedFilters.FonteID) {
          if (mergedFilters.sourceId) {
            const v = mergedFilters.sourceId.value ?? mergedFilters.sourceId
            mergedFilters.FonteID = { value: v }
            delete mergedFilters.sourceId
          } else if (fonteIdFromStorage) {
            mergedFilters.FonteID = { value: fonteIdFromStorage }
          }
        }

        const { items, total, pageCount } = await this.getDicomPlus(
          mergedFilters,
          page,
          this.pageSize,
          this.OrderColumn || 'dataExame',
          this.OrderBy || 'desc'
        )

        this.data = items
        this.totalItems = total
        this.pageCount = pageCount
      } catch (err) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.error_fetching_data'),
          text: err.message || err,
          confirmButtonText: 'Ok',
        })
      } finally {
        this.$root.$emit('hideLoading')
        this.isLoading = false
      }
    },
    async refreshGrid() {
      this.$root.$emit('showLoading')
      await this.fetchExams(this.activeFilters, this.currentPage)
      this.$root.$emit('hideLoading')
    },
    getStatusLabel(value) {
      const p = this.status.find((s) => s.value === value)
      return p ? p.label : value
    },
    async buscarAnexoTipo() {
      this.anexoTipoOptions = await this.getFileTypes()
    },
    // Filtro
    applyFilter() {
      if (this.searchTerm && this.searchTerm.length >= 3) {
        this.activeFilters = {
          ...this.activeFilters,
          patientName: { value: this.searchTerm }
        }
        this.currentPage = 1
        this.fetchExams(this.activeFilters, 1)
      } else {
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.warn'),
          text: this.$t('dicom_plus.dialog_message.enter_at_least_3_characteres_to_filter'),
          confirmButtonText: 'Ok',
        })
      }
    },
    clearTextFilter(){
      this.searchTerm = ''
    },
    clearFilter() {
      this.searchTerm = '';
      this.filtroStatus = 0;
      this.filtroPrioridade = '';
      this.filtroCategoria = '';
      this.activeFilters = { Status: { value: 0 } };
      this.currentPage = 1;
      this.fetchExams(this.activeFilters, 1)
    },
    filtrarPorStatus(status) {
      let statusId = status
      if (status && typeof status === 'object' && 'id' in status) {
        statusId = status.id
      }
      if (statusId !== null && statusId !== undefined && statusId !== '') {
        this.filtroStatus = statusId
        this.activeFilters = { ...(this.activeFilters || {}), Status: { value: statusId } }
      } else {
        if (this.activeFilters) {
          delete this.activeFilters.Status
          if (Object.keys(this.activeFilters).length === 0) {
            this.activeFilters = null
          }
        }
        this.filtroStatus = ''
      }
      this.currentPage = 1
      this.fetchExams(this.activeFilters, 1)
    },
    filtrarPorCategoria(categoria) {
      let categoriaId = categoria
      if (categoria && typeof categoria === 'object' && 'id' in categoria) {
        categoriaId = categoria.id
      }
      if (categoriaId !== null && categoriaId !== undefined && categoriaId !== '') {
        this.filtroCategoria = categoriaId
        this.activeFilters = { ...(this.activeFilters || {}), ModalityID: { value: categoriaId } }
      } else {
        if (this.activeFilters) {
          delete this.activeFilters.ModalityID
          if (Object.keys(this.activeFilters).length === 0) {
            this.activeFilters = null
          }
        }
        this.filtroCategoria = ''
      }
      this.currentPage = 1
      this.fetchExams(this.activeFilters, 1)
    },
    filtrarPorPrioridade(prioridadeId) {
      if (prioridadeId) {
        this.filtroPrioridade = prioridadeId;
        this.activeFilters = { ...(this.activeFilters || {}), Prioridade: { value: prioridadeId } };
      } else {
        if (this.activeFilters) {
          delete this.activeFilters.Prioridade;
          if (Object.keys(this.activeFilters).length === 0) {
            this.activeFilters = null;
          }
        }
        this.filtroPrioridade = '';
      }
      this.currentPage = 1;
      this.fetchExams(this.activeFilters, 1);
    },
    removeFilter(key) {
      if (this.activeFilters) {
        delete this.activeFilters[key];
        if (Object.keys(this.activeFilters).length === 0) {
          this.activeFilters = null;
        }
      }
      this.currentPage = 1;
      this.fetchExams(this.activeFilters, 1);
    },
    getFilterChipLabel(key, value) {
      switch (key) {
        case 'Status': {
          const id = value && typeof value === 'object' && 'id' in value ? value.id : value;
          const item = this.statusItems.find(i => String(i.id) === String(id));
          return `Status: ${item ? item.name : id ?? ''}`;
        }
        case 'Prioridade': {
          const id = value && typeof value === 'object' && 'id' in value ? value.id : value;
          const item = this.prioridadesItems.find(i => String(i.id) === String(id));
          return `Prioridade: ${item ? item.name : id ?? ''}`;
        }
        case 'FonteID': {
          if (Array.isArray(value)) {
            const labels = value.map(fid => {
              const fonte = this.formattedExamSources.find(f => String(f.id) === String(fid));
              return fonte ? fonte.value : fid;
            });
            return `Fonte: ${labels.join(', ')}`;
          } else {
            const fonte = this.formattedExamSources.find(f => String(f.id) === String(value));
            return `Fonte: ${fonte ? fonte.value : value ?? ''}`;
          }
        }
        case 'ModalityID': {
          const id = value && typeof value === 'object' && 'id' in value ? value.id : value;
          const item = this.categorias.find(i => String(i.id) === String(id));
          return `Categoria: ${item ? item.name : id ?? ''}`;
        }
        case 'patientName': {
          return `Paciente: ${typeof value === 'object' && value ? value.value : value ?? ''}`;
        }
        default:
          return `${key}: ${value ?? ''}`;
      }
    },
    // Paginação
    goToPage(page) {
      if (page < 1 || page > this.pageCount) return
      this.currentPage = page
      this.fetchExams(this.activeFilters, page)
    },
    nextPage() {
      this.goToPage(this.currentPage + 1)
    },
    prevPage() {
      this.goToPage(this.currentPage - 1)
    },
    onPageSizeChange() {
      this.currentPage = 1;
      this.fetchExams(this.activeFilters, 1);
    },
    searchError(errorMessage) {
      if (errorMessage) {
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.warn'),
          text: errorMessage,
          confirmButtonText: 'Ok',
        })
      }
    },

    async isExameAtribuido(item) {
      if (item?.status === constants.DICOM_PLUS_STATUS.REVISADO) {
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.exam_in_review_title'),
          text: this.$t('dicom_plus.dialog_message.exam_in_review_text'),
          confirmButtonText: 'Ok'
        })
        return;
      }

      if (item?.status !== 0) {
      this.openModal(item);
      return;
      }

      const dicomPlusID = item?.dicomPlusID;
      const res = await this.verificarExameEmUso(dicomPlusID);

      try {
        if (res.status === 200)
          this.openModal(item)

        if (res.status === 226) {
          showDialog({
            icon: 'warning',
            title: this.$t('dicom_plus.dialog_message.exam_in_use'),
            text: res.data?.data,
            confirmButtonText: 'Ok',
            confirmed: () => this.refreshGrid()
          })

        }

        if (res.status === 400) {
          showDialog({
            icon: 'error',
            title: 'Ops...',
            text: res.data?.data,
            confirmButtonText: 'Ok'
          })
        }

      } catch (error) {
        showDialog({
            icon: 'error',
            title: this.$t('dicom_plus.dialog_message.error_when_opening_exam'),
            text: error.message,
            confirmButtonText: 'Ok'
          })
      }

    },
    openModal(item) {
      this.selectedExam = item
      this.showModal = true
    },
    async verificarExameEmUso(dicomPlusID) {
      return await this.isExamAssignedToUser(dicomPlusID);
    },
    async desbloquearExame(item) {
      await showDialog({
        title: this.$t('dicom_plus.dialog_message.unlock'),
        text: this.$t('dicom_plus.dialog_message.exam_in_use_by', {user: item.usuarioEmUso}),
        icon: 'question',
        confirmButtonText: this.$t('dicom_plus.dialog_message.yes_unlock'),
        denyButtonText: this.$t('dicom_plus.dialog_message.no_cancel'),
        confirmed: async () => {

          const dicomPlusID = item?.dicomPlusID;
          try {
            const res = await this.removeAssignedUserToExam(dicomPlusID);
            if (res.success === true)
            {
              showDialog({
                icon: 'success',
                title: this.$t('dicom_plus.dialog_message.exam_unlocked'),
                text: this.$t('dicom_plus.dialog_message.exam_unlocked_successfully'),
                confirmButtonText: 'Ok',
                confirmed: () => this.refreshGrid()
              })
            }
          } catch (error) {
            showDialog({
            title: this.$t('dicom_plus.dialog_message.fail'),
            text: error,
            icon: 'warning',
            confirmButtonText: 'Ok'
          })}

        }
      })
    },
    // Ordenação
    sortTable(field) {
      if (this.OrderColumn === field) {
        this.OrderBy = this.OrderBy === 'asc' ? 'desc' : 'asc';
      } else {
        this.OrderColumn = field
        this.OrderBy = 'desc'
      }
      this.fetchExams(this.activeFilters, this.currentPage)
    },
    // Atualização de dados
    async atualizarCategoria(item) {
      const dicomPlusID = item?.dicomPlusID;
      const res = await this.verificarExameEmUso(dicomPlusID);

      try {
        if (res.status === 200){
          const payload = {
            modality: item.categoria,
            studyInstanceUID: item.studyInstanceUID
          }

          this.$root.$emit('showLoading')
          try {
            await this.salvarCategoria(payload)
            showDialog({
              icon: 'success',
              title: this.$t('dicom_plus.dialog_message.success'),
              text: this.$t('dicom_plus.dialog_message.registration_updated_succesfully'),
              confirmButtonText: 'OK'
            })
          } catch (error) {
            showDialog({
              icon: 'error',
              title: this.$t('dicom_plus.dialog_message.saving_error'),
              text: error,
              confirmButtonText: 'OK'
            })
          } finally {
            this.$root.$emit('hideLoading')
          }
        }

        if (res.status === 226) {
          showDialog({
            icon: 'warning',
            title: this.$t('dicom_plus.dialog_message.exam_in_use'),
            text: res.data?.data,
            confirmButtonText: 'Ok',
            confirmed: () => this.refreshGrid()
          })
          return
        }

        if (res.status === 400) {
          showDialog({
            icon: 'error',
            title: 'Ops...',
            text: res.data?.data,
            confirmButtonText: 'Ok'
          })
        }

      } catch (error) {
        showDialog({
            icon: 'error',
            title: this.$t('dicom_plus.dialog_message.open_exam_error'),
            text: error.message,
            confirmButtonText: 'Ok'
          })
      }
    },
    getPrioridadeLabel(value) {
      const p = this.prioridades.find((pri) => pri.value === value)
      return p ? p.label : value
    },
    openExamXView(url) {
      window.open(url, '_blank')
    },
    async handleGetExamXView(item) {
      const res = await this.getExamXView(item.studyInstanceUID)
      if (!res?.exameURL?.length) return
      this.openExamXView(res.exameURL)
    },
    // Anexar arquivos
    async abrirModalAnexarArquivos(item) {
      this.examAnexo = item
      await this.buscarListaDeArquivos(item)
      this.showAnexarArquivos = true
    },
    async abrirModalHistoricoExame(item) {
      const dicomPlusID = item?.dicomPlusID
      if (!dicomPlusID) return
      this.$root.$emit('showLoading')
      try {
        const res = await this.getDicomPlusHistory(dicomPlusID)
        this.historico = res?.timeLineHistories || []
        this.detalhes = res?.details || []
        this.dicomPlusIdSelecionado = dicomPlusID

        this.showHistoricoExame = true
      } catch (error) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.search_data_error') || 'Erro',
          text: error && error.message ? error.message : String(error),
          confirmButtonText: 'Ok',
        })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async buscarListaDeArquivos(item) {
      const dicomPlusID = item?.dicomPlusID
      if (!dicomPlusID) return
      const res = await this.getFileList(dicomPlusID)
      this.savedFiles = res || []
    },
    fecharModalAnexarArquivos() {
      this.showAnexarArquivos = false
      this.examAnexo = null
    },
    async salvarArquivos({ files }) {
      const dicomPlusID = this.examAnexo?.dicomPlusID
      const filesPayload = []
      try {
        this.$root.$emit('showLoading')
        for (const file of files) {
          const urlInfo = await this.criarUrlAssinadaUploadCloud(file)
          if (!urlInfo.success) {
            showDialog({
              icon: 'error',
              title: this.$t('dicom_plus.dialog_message.fail'),
              text: urlInfo.message,
              confirmButtonText: 'OK'
            })
            continue
          }

          const uploadResult = await this.uploadExameStorage(urlInfo.uploadUrl, file.file)
          if (!uploadResult.success) {
            showDialog({
              icon: 'error',
              title: this.$t('dicom_plus.dialog_message.fail_save_storage'),
              text: uploadResult.message,
              confirmButtonText: 'OK'
            })
            continue
          }

          filesPayload.push({
            linkStorage: urlInfo.publicUrl,
            tipoAnexo: file.tipoAnexo
          })
        }

        if (filesPayload.length) {
          const payload = {
            dicomPlusID,
            files: filesPayload
          }
          const resultado = await this.salvarAnexoLocal(payload)
          if (!(resultado && resultado.success)) {
            showDialog({
              icon: 'error',
              title: this.$t('dicom_plus.dialog_message.fail'),
              text: resultado.message || this.$t('dicom_plus.dialog_message.fail_save_storage'),
              confirmButtonText: 'OK'
            })
          } else {
            showDialog({
              icon: 'success',
              title: this.$t('dicom_plus.dialog_message.success'),
              text: this.$t('dicom_plus.dialog_message.files_saved_succesfully'),
              confirmButtonText: 'OK'
            })
          }
        }

      } finally {
        await this.buscarListaDeArquivos(this.examAnexo);
        this.$refs.importFilesModal.clearImportedFiles()
        this.$root.$emit('hideLoading')
      }
    },
    async confirmaExcluirArquivoSalvo(id){
      await showDialog({
          title: this.$t('dicom_plus.dialog_message.confirmation'),
          text: this.$t('dicom_plus.dialog_message.confirm_attachment_deletion'),
          confirmButtonText: this.$t('dicom_plus.yes'),
          denyButtonText: this.$t('dicom_plus.no'),
          icon: 'question',
          focusConfirm: false,
          focusDeny: true,
          confirmed: () => this.excluirArquivoSalvo(id)
        })
    },
    async excluirArquivoSalvo(id) {
      try {
        this.$root.$emit('showLoading')
        await this.deleteFiles(id)
        await this.buscarListaDeArquivos(this.examAnexo)
        showDialog({
          icon: 'success',
          title: this.$t('dicom_plus.dialog_message.success'),
          text: this.$t('dicom_plus.dialog_message.files_removed_succesfully'),
          confirmButtonText: 'OK'
        })
        } catch (e) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.delete_error'),
          text: e,
          confirmButtonText: 'OK'
        })
        } finally {
          this.$root.$emit('hideLoading')
        }
    },
    getStatusClass(status) {
      const statusClassMap = {
        '0': 'status primary',
        '1': 'status success',
        '2': 'status info',
        '3': 'status warning',
        '4': 'status expired',
        '5': 'status deleted',
        '99': 'status danger'
      }
      return statusClassMap[status] || 'status-default'
    },
    getStatusIcon(status) {
      const statusIconMap = {
        '0': 'alarm',
        '1': 'check',
        '2': 'assignment',
        '3': 'warning',
        '4': 'hourglass_bottom',
        '5': 'delete',
        '99': 'close'
      }
      return statusIconMap[status] || 'fas fa-circle'
    },
    async confirmarReativarExame(item) {
      this.examToReactive = item
        await showDialog({
          title: this.$t('dicom_plus.dialog_message.confirmation'),
          text: this.$t('dicom_plus.dialog_message.confirm_to_reactive'),
          confirmButtonText: this.$t('dicom_plus.yes'),
          denyButtonText: this.$t('dicom_plus.no'),
          icon: "question",
          focusConfirm: false,
          focusDeny: true,
          confirmed: this.reactiveDicomPlus
        })
    },
    abrirCancelamento(item) {
      const dicomPlusID = item?.dicomPlusID

      if (!dicomPlusID)
        return

      this.dicomPlusIdSelecionado = item.dicomPlusID;
      this.localMotivoCancelamento = '';
      this.showCancelModal = true;
    },
    fecharCancelamento() {
      this.showCancelModal = false;
      this.dicomPlusIdSelecionado = null;
      this.localMotivoCancelamento = '';
    },
    async reactiveDicomPlus(){
      if (!this.examToReactive) return;
      const payload = {
        dicomPlusID: this.examToReactive.dicomPlusID,
        studyInstanceUID: this.examToReactive.studyInstanceUID,
        accessionNumber: this.examToReactive.accessionNumber,
        stationName: this.examToReactive.stationName,
        fonteID: this.examToReactive.fonteID,
        modality: this.examToReactive.categoria,
        patientName: this.examToReactive.paciente,
        patientID: this.examToReactive.patientID,
        patientBirthDate: dateBrToInt(this.examToReactive.dataNascimento),
        patientSex: this.examToReactive.sexo.trim(),
        studyDescription: this.examToReactive.studyDescription,
        patientComments: this.examToReactive.comentarios || '',
        tituloLaudo: this.examToReactive.tituloLaudo || null,
        status: constants.DICOM_PLUS_STATUS.PENDENTE,
        studyDate: this.examToReactive.studyDate,
        studyTime: this.examToReactive.studyTime,
        requestingPhysicianName: this.examToReactive.requestingPhysicianName,
        patientWeight: this.examToReactive.patientWeight,
        token: this.examToReactive.token,
        especialidadeID: this.examToReactive.especialidade ||'',
        subEspecialidade: this.examToReactive.subEspecialidade ||'',
        contraste: this.examToReactive.contraste ||'',
        contrasteVia: this.examToReactive.contrasteVia ||'',
        contrasteTipo: this.examToReactive.contrasteTipo ||'',
        trauma: this.examToReactive.trauma ||'',
        avc: this.examToReactive.avc ||'',
        leito: this.examToReactive.leito ||'',
        oncologico: this.examToReactive.oncologico ||'',
        prioridade: this.examToReactive.prioridade ||'',
        dadosComplementares: this.examToReactive.formComplementares || '',
        tagsPlus: this.examToReactive.dadosComplementaresJSON || '',
        mamografia: this.examToReactive.mamografia || '',
        medicoID: this.examToReactive.medicoID || '',
        nomeMedico: this.examToReactive.nomeMedico || '',
      }
      this.$root.$emit('showLoading');
      try {
        await this.updatePaciente(payload);
        showDialog({
            icon: 'success',
            title: this.$t('dicom_plus.dialog_message.success'),
            text: this.$t('dicom_plus.dialog_message.reactived_successfully'),
            confirmButtonText: 'Ok',
          })
        this.refreshGrid();
      } catch (error) {
        showDialog({
            icon: 'error',
            title: this.$t('dicom_plus.dialog_message.error'),
            text: error || this.$t('dicom_plus.dialog_message.error_validating_data'),
            confirmButtonText: 'Ok',
          })
      } finally {
        this.$root.$emit('hideLoading');
      }
    },
    async handleDownloadLink(dicomPlusFileID) {
      this.$root.$emit('showLoading');
      try {
        const result = await this.criarUrlAssinadaDownloadCloud(dicomPlusFileID);

        if (result) {
          window.open(result.url, '_blank');
        } else {
          showDialog({
            icon: 'error',
            title: this.$t('dicom_plus.dialog_message.error_getting_download_link'),
            text: this.$t('dicom_plus.dialog_message.error_getting_download_link'),
            confirmButtonText: 'Ok',
          })
        }
      } catch (error) {
        showDialog({
            icon: 'error',
            title: this.$t('dicom_plus.dialog_message.failed_download_file'),
            text: error || this.$t('dicom_plus.dialog_message.failed_download_file'),
            confirmButtonText: 'Ok',
          })
      } finally {
        this.$root.$emit('hideLoading');
      }
    },
    handleKeyDown(e) {
      if (e.ctrlKey && e.key.toLowerCase() === 'i') {
        this.showIdColumn = !this.showIdColumn;
        localStorage.setItem('showIdColumn', this.showIdColumn);
        e.preventDefault();
      }
    },
    preventF5AndReloadGrid(e) {
      if (e.key === 'F5' || e.keyCode === 116) {
        e.preventDefault();
        this.refreshGrid();
      }
    },
  },
  async mounted() {
    const { categorias }= await this.getCategoriasDicomPlus()
    this.categorias = categorias
    this.prioridades = await this.getPriority()
    this.status = await this.getStatus()
    this.buscarAnexoTipo()
    this.$root.$emit('showLoading')

    this.fetchExams(this.activeFilters, this.currentPage).finally(() => {
      this.$root.$emit('hideLoading')
    })

    const stored = localStorage.getItem('showIdColumn');
    if (stored !== null) {
      this.showIdColumn = stored === 'true';
    }
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keydown', this.preventF5AndReloadGrid);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keydown', this.preventF5AndReloadGrid);
  },
}
